import React from "react";
import { httpClient } from "../../helper/utils";
import { Constant } from "../../helper/constant";

/**
 * @param {string} id
 * @param {Omit<RequestInit, "method" | "headers">} [requestInit]
 */
export async function getProductById(id, requestInit) {
  const token = localStorage.getItem("token")
  const response = await httpClient(
    `${Constant.BASE_API_URL}/produk/${id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      ...requestInit,
    }
  );
  return response.json();
}

export function useProductDetail(id, shouldFetch = true) {
  const [data, setData] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const [isError, setIsError] = React.useState(false)

  React.useEffect(() => {
    if (!shouldFetch) {
      return
    }

    (async () => {
      setIsLoading(true)
      try {
        const response = await getProductById(id)
        setData(response.data)
        setIsLoading(false)
      } catch (err) {
        setData(null)
        setIsLoading(false)
        setIsError(true)
      }
    })();
  }, [id, shouldFetch])

  return {
    data,
    isLoading,
    isError,
  }
}
